import { render, staticRenderFns } from "./ApprovalHeader.vue?vue&type=template&id=4a27c666&scoped=true&"
import script from "./ApprovalHeader.vue?vue&type=script&lang=js&"
export * from "./ApprovalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalHeader.vue?vue&type=style&index=0&id=4a27c666&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a27c666",
  null
  
)

export default component.exports